var render, staticRenderFns
import script from "./InspectionCostPageQuick.vue?vue&type=script&lang=ts&"
export * from "./InspectionCostPageQuick.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCostPageQuick.vue?vue&type=style&index=0&id=5d3ffb89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ffb89",
  null
  
)

export default component.exports